import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
} from "@mui/material";
import {
  insertTimeIncidencesQuality,
  fullDataPiece,
} from "../../services/ConnectDataBase.js";
import { updateInfoData } from "../../redux/reducers";
import { useSelector, useDispatch } from "react-redux";
import {
  SCREEN_IDS,
  typeConnect,
  backgroundColor2,
} from "../../constants/Constants";
import { getArrayInfoDataUpdate } from "../../services/Functions";
import { translateText } from "../../translations/translationService";
import { BACKGROUND_COLORS, TEXT_COLORS, BRAND_COLORS } from "../../style/colors.js";
import { notify } from "../../services/ui/notify";

const SimplifiedCronometroIncidencias = ({
  screen,
  po,
  mo,
  fulldata,
  listIncidencias,
  totalIncidencias,
  navigation,
}) => {
  const dispatch = useDispatch();
  const [isRunning, setIsRunning] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [finishModalVisible, setFinishModalVisible] = useState(false);
  const [selectedIncidentOption, setSelectedIncidentOption] = useState(null);
  const [pieceCount, setPieceCount] = useState("");
  const [startDate, setStartDate] = useState(null);
  const currentScreenId = SCREEN_IDS.GENERAL;
  const startTimeRef = useRef(null);
  const timerRef = useRef(null);
  const name = useSelector((state) => state.user.name);
  const team = useSelector((state) => state.user.team);
  const cod_team = useSelector((state) => state.user.cod_team);
  const [isProcessing, setIsProcessing] = useState(false);
  const lang = useSelector((state) => state.lang.value);
  const cantidadTotal = parseFloat(fulldata.cantidad) || 0;
  const cantidadFabricada = parseFloat(fulldata.cantidad_fabricada) || 0;
  const cantidadTerminada = parseFloat(fulldata.cantidad_terminada) || 0;
  const cantidadRestante = cantidadTotal - cantidadTerminada;

  useEffect(() => {
    if (isRunning) {
      startTimeRef.current = Date.now() - elapsedTime;
      timerRef.current = setInterval(() => {
        setElapsedTime(Date.now() - startTimeRef.current);
      }, 1000);
    } else if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [isRunning]);
  useEffect(() => {
    const unsubscribe = navigation.addListener("beforeRemove", (e) => {
      // Si el cronómetro no está corriendo, permites salir
      if (!isRunning) return;

      // Si está corriendo, bloqueas
      e.preventDefault();
      notify.warn("¡Cronómetro activo! Debes pararlo antes de salir.");
    });

    return () => {
      unsubscribe();
    };
  }, [navigation, isRunning]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n) => (n < 10 ? "0" + n : n);
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  const showAlert = (title, message) => {
    const fullMessage = `${title}: ${message}`;
    if (String(title).toLowerCase() === "error") {
      notify.error(fullMessage);
    } else {
      notify.warn(fullMessage);
    }
  };

  const handleStart = () => {
    if (cantidadFabricada >= cantidadTotal) {
      showAlert("Información", "Todas las piezas ya han sido fabricadas.");
      return;
    }

    const incidenciasPendientes = listIncidencias.filter(
      (inc) => inc.cantidad_incidencia > 0
    );

    if (incidenciasPendientes.length === 1) {
      iniciarContador(incidenciasPendientes[0]);
    } else if (incidenciasPendientes.length > 1) {
      setModalVisible(true);
    } else {
      showAlert(
        "Error",
        "No hay incidencias pendientes para iniciar el tiempo."
      );
    }
  };

  const iniciarContador = (incidencia) => {
    setSelectedIncidentOption(incidencia);
    setIsRunning(true);
    let tzoffset = new Date().getTimezoneOffset() * 60000; // Offset en milisegundos
    let localISOTime = new Date(Date.now() - tzoffset)
      .toISOString()
      .slice(0, -1);
    setStartDate(localISOTime);
  };

  const handleFinish = () => {
    if (isRunning) {
      setIsRunning(false);
    }
    setFinishModalVisible(true);
  };

  const handleModalAccept = () => {
    if (selectedIncidentOption) {
      setModalVisible(false);
      iniciarContador(selectedIncidentOption);
    } else {
      notify.warn("Por favor, selecciona una incidencia antes de continuar.");
    }
  };

  const handlePieceCountChange = (value) => {
    const numericValue = parseFloat(value);
    if (numericValue > parseFloat(selectedIncidentOption.cantidad_incidencia)) {
      notify.warn(
        `La cantidad no puede ser mayor a ${selectedIncidentOption.cantidad_incidencia}.`
      );
      setPieceCount("");
    } else {
      setPieceCount(value);
    }
  };

  // const handleStop = async () => {
  //   if (isProcessing) {
  //     return;
  //   }

  //   setIsProcessing(true);

  //   try {
  //     const now = new Date();
  //     const isoFormattedEndDate = now.toISOString();

  //     const dataToSend = {
  //       mo,
  //       user: name,
  //       team,
  //       process: selectedIncidentOption,
  //       startDate,
  //       endDate: isoFormattedEndDate,
  //       durationMs: elapsedTime,
  //       durationFormatted: formatTime(elapsedTime),
  //       pieceCount,
  //     };

  //     await insertTimeIncidencesQuality(
  //       currentScreenId,
  //       typeConnect[1],
  //       "cronometroIncidencesQuality",
  //       dataToSend
  //     );

  //     const newInfo = await fullDataPiece(mo, 2);
  //     const infoData = getArrayInfoDataUpdate(newInfo);
  //     dispatch(updateInfoData(infoData));

  //     setFinishModalVisible(false);
  //     setElapsedTime(0);
  //     setPieceCount("");
  //     setSelectedIncidentOption(null);
  //     setStartDate(null);
  //   } catch (error) {
  //     console.error("Error al guardar datos:", error);
  //   } finally {
  //     setIsProcessing(false);
  //   }
  // };
  const handleStop = async () => {
    if (isProcessing) {
      return;
    }

    setIsProcessing(true);

    try {
      let tzoffset = new Date().getTimezoneOffset() * 60000; // Offset en milisegundos
      let localISOTime = new Date(Date.now() - tzoffset)
        .toISOString()
        .slice(0, -1);
      const isoFormattedEndDate = localISOTime;

      const dataToSend = {
        mo,
        user: name,
        team,
        process: selectedIncidentOption,
        startDate,
        endDate: isoFormattedEndDate,
        durationMs: elapsedTime,
        durationFormatted: formatTime(elapsedTime),
        pieceCount,
      };

      await insertTimeIncidencesQuality(
        currentScreenId,
        typeConnect[1],
        "cronometroIncidencesQuality",
        dataToSend
      );

      const newInfo = await fullDataPiece(mo, 2);
      const infoData = getArrayInfoDataUpdate(newInfo);
      dispatch(updateInfoData(infoData));

      setFinishModalVisible(false);
      setElapsedTime(0);
      setPieceCount("");
      setSelectedIncidentOption(null);
      setStartDate(null);
    } catch (error) {
      console.error("Error al guardar datos:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      {!isRunning ? (
        <Button
          variant='contained'
          onClick={handleStart}
          sx={{
            mr: 2,
            fontSize: 20,
            flexGrow: 1,
            backgroundColor: backgroundColor2, // Color de fondo del botón Iniciar
            color: TEXT_COLORS.LIGHT, // Color del texto
            "&:hover": {
              backgroundColor: BRAND_COLORS.PRIMARY_LIGHT, // Color de fondo al hacer hover
            },
          }}>
          {translateText("Iniciar", lang)}
        </Button>
      ) : (
        <Button
          variant='contained'
          onClick={handleFinish}
          sx={{ mr: 2, fontSize: 20, flexGrow: 1 }}>
          {translateText("Finalizar", lang)}
        </Button>
      )}

      <Box
        sx={{
          backgroundColor: BACKGROUND_COLORS.SECONDARY,
          padding: 1,
          borderRadius: 1,
          minWidth: 100,
          textAlign: "center",
          mr: 2,
          flexGrow: 1,
        }}>
        <Typography variant='h6' sx={{ color: TEXT_COLORS.DARK }}>
          {formatTime(elapsedTime)}
        </Typography>
      </Box>

      {/* Modal para seleccionar incidencia */}
      <Modal open={modalVisible} onClose={() => setModalVisible(false)}>
        <Box sx={modalStyle}>
          <Typography variant='h6' gutterBottom>
            {translateText("Selecciona una incidencia", lang)}:
          </Typography>
          <List>
            {listIncidencias
              .filter((inc) => inc.cantidad_incidencia > 0)
              .map((item, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemButton
                    selected={selectedIncidentOption === item}
                    onClick={() => setSelectedIncidentOption(item)}>
                    <ListItemText
                      primary={`${item.Problema} - ${item.Solución} (Cantidad: ${item.cantidad_incidencia})`}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
          </List>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              onClick={handleModalAccept}
              variant='contained'
              disabled={!selectedIncidentOption}
              sx={{ mr: 2 }}>
              {translateText("Aceptar", lang)}
            </Button>
            <Button onClick={() => setModalVisible(false)} variant='outlined'>
              {translateText("Cancelar", lang)}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal al finalizar */}
      <Modal
        open={finishModalVisible}
        onClose={() => setFinishModalVisible(false)}>
        <Box sx={modalStyle}>
          <Typography variant='h6' gutterBottom>
            {translateText("Nº de piezas terminadas", lang)}:
          </Typography>
          <TextField
            value={pieceCount}
            onChange={(e) => handlePieceCountChange(e.target.value)}
            type='number'
            variant='outlined'
            fullWidth
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              onClick={handleStop}
              variant='contained'
              disabled={
                isProcessing || !pieceCount || parseFloat(pieceCount) === 0
              }
              sx={{ mr: 2 }}>
              {translateText("Aceptar", lang)}:
            </Button>
            <Button
              onClick={() => setFinishModalVisible(false)}
              variant='outlined'>
              {translateText("Cancelar", lang)}:
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  maxHeight: "80%",
  overflowY: "auto",
};

export default SimplifiedCronometroIncidencias;
